// 회신 결과 탭 라벨 — 서버 ForemanConfirmResultService 의 reason · plan · reasonCode · 이력 status 값.
// 코드 값 타입은 api/foremanApi.ts, 한글 문구는 이 파일에서만 정의한다.
import type { PartnerChangeReasonCode } from '../api/foremanApi'

type BadgeTone = 'success' | 'info' | 'warning' | 'danger' | 'done' | 'mute'

/** 지금 처리할 일(🔴) 사유 → 배지 라벨 */
export const ACTION_REASON_LABEL: Record<string, { label: string; status: BadgeTone }> = {
  SEND_FAILED:   { label: '발송 실패',            status: 'danger' },
  DELIVERY_DEAD: { label: '전달 안 됨',           status: 'danger' },
  UNFIXED:       { label: '미확정',               status: 'danger' },
  DECLINED:      { label: '불가 회신',            status: 'danger' },
  UNASSIGNABLE:  { label: '배정 가능한 반장 없음', status: 'danger' },
  EXPIRED:       { label: '기한 지남',            status: 'warning' },
}

/** 자동 처리 예정(🟡) plan → 배지 라벨 */
export const PLAN_LABEL: Record<string, { label: string; status: BadgeTone }> = {
  AUTO_SEND:         { label: '자동 예정', status: 'info' },
  UNFIXED_ON_EXPIRE: { label: '회신 대기', status: 'warning' },
}

/** UNFIXED_ON_EXPIRE 의 reasonCode → 부가 문구 */
export const PLAN_REASON_TEXT: Record<string, string> = {
  AUTO_OFF:      '자동 발송이 꺼져 있어 기한이 지나면 할 일로 알려 드려요',
  LIMIT_REACHED: '자동 발송 한도를 넘어 기한이 지나면 할 일로 알려 드려요',
  NO_CANDIDATE:  '보낼 반장님이 없어 기한이 지나면 할 일로 알려 드려요',
}

/** 발송 실패 사유(failReason) → 문구 */
export const FAIL_REASON_LABEL: Record<string, string> = {
  NO_CONTACT:  '연락처 없음',
  SEND_FAILED: '발송 실패',
}

/** 전체 발송 이력 status → 배지 */
export const HISTORY_STATUS_BADGE: Record<string, { label: string; status: BadgeTone }> = {
  SEND_FAILED: { label: '발송 실패',    status: 'danger' },
  CLOSED:      { label: '마감',         status: 'mute' },
  CONFIRMED:   { label: '✓ 일정가능',   status: 'success' },
  DECLINED:    { label: '✕ 일정불가',   status: 'danger' },
  EXPIRED:     { label: '⏰ 기한 지남',  status: 'warning' },
  WAITING:     { label: '⏳ 회신 대기',  status: 'warning' },
}

/** 이력 closedReason → 기한 칸 문구 */
export const CLOSED_REASON_LABEL: Record<string, string> = {
  EXPIRED:  '기한 지남',
  REPLACED: '다른 반장으로 교체',
  CHANGED:  '일정 변경',
}

/** 이력 sendMethod → 발송 방식 라벨 */
export const SEND_METHOD_LABEL: Record<string, string> = {
  MANUAL: '직접',
  AUTO:   '자동',
  RESEND: '다시 보냄',
  CHANGE: '일정 변경 재확인',
}

/** 후보의 공종 일치(workTypeMatch) → 라벨 */
export function workTypeMatchLabel(match: string | null | undefined): string | null {
  switch (match) {
    case 'MAIN':       return '주작업'
    case 'SUB':        return '부작업'
    case 'DESIGNATED': return '주시공지정'
    default:           return null
  }
}

/** 확정 반장 변경 사유(E01_PARTNER_CHANGE_REASON) — 값은 서버 코드, 문구는 기획서 확정 반장 변경 경고(#gdWhy). */
export const PARTNER_CHANGE_REASONS: { value: PartnerChangeReasonCode; label: string }[] = [
  { value: 'CUSTOMER_REQUEST',     label: '고객 요청 일정 변경' },
  { value: 'PARTNER_CIRCUMSTANCE', label: '반장님 사정' },
  { value: 'QUALITY_HISTORY',      label: '품질 · 이력 문제' },
  { value: 'ETC',                  label: '기타' },
]

export const PARTNER_CHANGE_REASON_PLACEHOLDER = '변경 사유를 골라 주세요'
